<template>
  <OurConfirmModal
    v-model="isShownModal"
    :title="$t('title.knowledgeBase.delete')"
    :action-button-text="$t('button.remove')"
    color="gray"
    @actionConfirmed="onClickDeleteButton"
  >
    <OurTextBlock
      v-html="$t('page.knowledgeBase.removeConfirm', { name: knowledgeBaseSectionsName })"
    />
  </OurConfirmModal>
</template>

<script>
import apolloMixin from "@/mixins/apollo.mixin";
import { deleteKnowledgeBaseSectionMutation } from "./gql/mutations";

export default {
  name: "DeleteModal",

  mixins: [apolloMixin],

  props: {
    show: {
      type: Boolean,
      default: false,
    },

    knowledgeBaseSectionsId: {
      type: String,
      default: "",
    },

    knowledgeBaseSectionsName: {
      type: String,
      default: "",
    },

    delayNotify: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    isShownModal: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit("update:show", value);
      },
    },
  },

  methods: {
    closeModal() {
      this.isShownModal = false;
    },

    onClickCloseButton() {
      this.closeModal();
    },

    async onClickDeleteButton() {
      const { deleteKnowledgeBaseSection } = await this.$post(
        deleteKnowledgeBaseSectionMutation,
        { id: this.knowledgeBaseSectionsId },
        { delaySuccessNotify: this.delayNotify }
      );

      if (deleteKnowledgeBaseSection.id) this.$emit("deleteKnowledgeBaseSection");
    },
  },
};
</script>
